import type { ApiConfig } from '../../types'

export const depositHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 50,
  order: 'desc',
  range: 1000 * 60 * 60 * 24 * 30, // 30 days
  requiresRange: true,
  type: 'deposit-history',
} as const satisfies ApiConfig
